import { Button } from '@/shared/ui/button.tsx'
import { Form } from '@/shared/ui/form.tsx'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import InputWithLabel from '@/shared/inputs/InputWithLabel'
import { useAuth } from '../auth-view/api'
import { useContext } from 'react'
import { AuthContext, AuthContextType } from './context'

const loginSchema = z.object({
  username: z.string().min(1, { message: "Username is required" }),
  password: z.string().min(1, { message: "Password is required" })
})

type LoginSchemaType = z.infer<typeof loginSchema>

const PlaygroundLogin = () => {

  const { setPlaygorund } = useContext<AuthContextType>(AuthContext)

  const { loginUser, status } = useAuth()

  const form = useForm<LoginSchemaType>({
    defaultValues: {
      username: "",
      password: "",
    },
    resolver: zodResolver(loginSchema)
  })

  const submitHandler = (formData: LoginSchemaType) => {
    setPlaygorund(true)
    loginUser(formData)
    form.reset()
  }

  return (
    <div className='w-full h-[100vh] bg-top bg-cover max-sm:bg-[url(https://utfs.io/f/A17KOoeuO4h9HJY1v5NMor0Nh4Jfi5AVDOw6lmEq82F9dasj)] sm:bg-gray-100 flex p-10 gap-4 items-center justify-evenly'>
      <div className='w-full sm:w-1/2 h-full flex flex-col items-center justify-center gap-3'>
        <div id="card" className='bg-white max-sm:bg-white/85 h-fit w-full lg:w-2/3 rounded-2xl md:rounded-xl shadow-lg flex flex-col items-center p-3 md:p-4 gap-2'>
          <p className='font-header text-2xl w-full text-center pb-3'>Login in to siAi Playground</p>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(submitHandler)} className='flex flex-col w-full px-1 md:px-5 lg:px-10 pb-5 gap-5'>
              <InputWithLabel<LoginSchemaType> nameInSchema="username" fieldTitle="Username" />
              <InputWithLabel<LoginSchemaType> nameInSchema="password" type='password' fieldTitle="Password" />
              <Button className='rounded-xl font-montserrat' type='submit' disabled={status === "pending"}>Log in</Button>
            </form>
          </Form>
        </div>
      </div>
      <div className='w-1/2 hidden sm:block h-full bg-blue-50 bg-center bg-cover bg-[url(https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9IDgSWFqqx7JnezRM42NOs0kKBpFuST9W1Plh)] rounded-3xl'></div>
    </div>
  )
}

export default PlaygroundLogin
